import React from 'react';

import { getClassNames } from '../../../services/stylingUtils';

import styles from './styles.scss';

export default class ServiceReferrerLink extends React.Component {

    _getClassNames() {

        return getClassNames(styles, this.props.className, {
            'container': true
        });
    }

    render() {

        const { service: { name, service_url, theme_colour, font_colour } } = this.props;

        return (
            <div className={this._getClassNames()}>
                <a href={ service_url } className={styles['link']} style={{ color: font_colour, backgroundColor: theme_colour }}>
                    &larr; Back to { name }
                </a>
            </div>
        )
    }
}